import { REACT_APP_PROJECT_ID, REACT_APP_APPLICATION_URL } from "./Config";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { cookieStorage, createStorage, http } from "@wagmi/core";
import { createAppKit } from "@reown/appkit/react";
import { defineChain, sepolia, mainnet} from "@reown/appkit/networks";
import { AppConfig } from './app-config';

const projectId = REACT_APP_PROJECT_ID;

const metadata = {
  name: "openzk",
  description: "Web3Modal Example",
  url: REACT_APP_APPLICATION_URL, // origin must match your domain & subdomain
  icons: ["https://avatars.githubusercontent.com/u/37784886"],
};

const sepoliaTransport = http(
  'https://eth-sepolia.g.alchemy.com/v2/PQae1A79paBU9liPS1kdZ61HS5O5KJUd',
);
const mainnetTransport = http(
  'https://eth-mainnet.g.alchemy.com/v2/ikiqikM7uHSREHr8SWuedwKSYs5f-tC0',
);

const transports = AppConfig.isDev
  ? {
    [sepolia.id]: sepoliaTransport,
  }
  : {
    [mainnet.id]: mainnetTransport,
  };
const networks = AppConfig.isDev
  ? [sepolia]
  : [mainnet];

export const wagmiAdapter = new WagmiAdapter({
  projectId,
  networks,
  storage: createStorage({
    storage: cookieStorage,
  }),
  transports,
});

createAppKit({
  metadata,
  projectId,
  adapters: [wagmiAdapter],
  networks: AppConfig.isDev
    ? [sepolia]
    : [mainnet],
  defaultNetwork: AppConfig.isDev
    ? sepolia: mainnet,
  features: {
    email: false,
    socials: [],
  },
  includeWalletIds: [
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
    '971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709',
    '38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662',
    '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
    '20459438007b75f4f4acb98bf29aa3b800550309646d375da5fd4aac6c2a2c66',
    '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4',
  ],
});

const config = wagmiAdapter.wagmiConfig;

export default config;
